import type { UserOnboardingStatus as Source } from '../../state/api/axilon-v2-api.generated'
import { pinEnum } from '../utils/pin-enum'

export const OnboardingStatus = {
  Completed: 'completed',
  Pending: 'pending'
} as const
export type OnboardingStatus = (typeof OnboardingStatus)[keyof typeof OnboardingStatus]

pinEnum<OnboardingStatus, Source>()
